module.exports = __webpack_public_path__ + "img/pic-0122.64adbecb.png";